export enum AppLocationEnum {
  NL = 'NL',
  BE = 'BE',
}
